import React, { memo, useEffect } from "react";
import { Typography } from "@mui/material";
import { useField } from "formik";

import RpCurrencyField from "@/components/muiCustom/textField/RpCurrencyField";
import RRDDirectMailToolTips from "../RRDDirectMailToolTips";

const CurrencyField = RpCurrencyField as React.ElementType;

function RRDDirectDistributionCostInput({
  name = "distribution_cost",
  distributionToggleName = "distribution",
  distributionCostAdmin,
}) {
  const [distributionCostField, , distributionCostFieldHelper] = useField(name);
  const [distributionField] = useField(distributionToggleName);

  useEffect(() => {
    if (distributionToggleName) {
      if (!distributionField.value) {
        distributionCostFieldHelper.setValue(0);
      } else {
        distributionCostFieldHelper.setValue(distributionCostAdmin);
      }
    }
  }, [distributionField.value, distributionCostAdmin, distributionToggleName]);

  return (
    <>
      <Typography variant="body2" gutterBottom fontWeight={600}>
        Cost <RRDDirectMailToolTips type="distribution_cost" />
      </Typography>
      <CurrencyField
        fullWidth
        size="small"
        value={distributionCostField.value}
        disabled={!distributionField.value}
        readOnly
        placeholder="0.00"
        fixedDecimalScale={true}
        sx={{
          "& .MuiOutlinedInput-root": {
            opacity: 0.6,
            pointerEvents: "none",
          },
        }}
      />
    </>
  );
}

export default memo(RRDDirectDistributionCostInput);
